module.exports = __webpack_public_path__ + "static/img/RPA-C-01-21_6.bf3ecfa.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/RPA-C-01-21_6.jpeg
// module id = I0TK
// module chunks = 9